// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';

const CropperForm = React.memo((props) => (
  <div className={`col-md-6 col-lg-5 overflow-auto ${props.className}`}>
    <div className="p-5 d-flex w-100 justify-content-center align-items-center">
      {props.renderForm()}
    </div>
  </div>
));

CropperForm.propTypes = {
  className:  PropTypes.string.isRequired,
  renderForm: PropTypes.func.isRequired,
};

export default CropperForm;
